import {Component} from '@angular/core';
import {StateService} from '../../core/services/state/state.service';
import {ThemeService} from '../../core/services/theme/theme.service';

@Component({
  selector: 'xp-authentication',
  templateUrl: './authentication.component.html',
  styleUrl: './authentication.component.scss',
})
export class AuthenticationComponent {

  constructor(
    private readonly _stateService: StateService,
    private readonly _themeService: ThemeService,
  ) {
  }

  public get logoUrl(): string {
    if (this._themeService.darkTheme) {
      return 'assets/images/xp-logo-teal.svg';
    }
    return 'assets/images/xp-logo.svg';
  }

  public get appVersion(): string {
    return this._stateService.appVersion;
  }

}
